export type SocialLinkType = {
	name: string;
	link: string;
	src: string;
};

export const SOCIAL_LINKS: Array<SocialLinkType> = [
	{
		name: 'Instagram',
		link: 'https://www.instagram.com/SweatPals_Austin',
		src: '/assets/icons/instagram.svg'
	},
	{
		name: 'TikTok',
		link: 'https://www.tiktok.com/@sweatpals?_t=8VcheTvrcWE&_r=1',
		src: '/assets/icons/tik-tok.svg'
	},
	{
		name: 'Facebook',
		link: 'https://www.facebook.com/SweatPalsAustin',
		src: '/assets/icons/facebook.svg'
	}
];
